/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FaRegEdit } from 'react-icons/fa'
import Table from '../../components/Table/Table'
import AddUpdateICO from './Components/AddUpdateICO'
import DeletePopup from '../../components/DeletePopup.js/DeletePopup'
import Loader from '../../components/Loader/Loader'
import { toast } from 'react-toastify'
import moment from "moment"
import { getICOList, updateIco } from '../../Redux/icoSlice'
import Pagination from '../../components/Pagination/Pagination'

const size = 10
const initialFormState = {
  name: '',
  description: '',
  startDate: '',
  endDate: '',
  videoUrl: ''
}

const ICO = () => {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const { ico } = selector || {}
  const { icoListData, total, loading } = ico || {}
  const [pageNo, setPageNo] = useState(1)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [errors, setErrors] = useState({})
  const [formData, setFormData] = useState(initialFormState)
  const [isUpdateMode, setIsUpdateMode] = useState(false)
  const [keyWord, setKeyWord] = useState('')
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const tableHeadings = ['#',  'ICO Start Date', 'ICO End Date', "Action"]



  const tableRows =
    Array.isArray(icoListData?.list) &&
    icoListData?.list?.map((ele, index) => {
      return [
        (pageNo - 1) * size + (index + 1),
        // ele?.name ?? 'N/A',
        // <div className='max-w-xs'>
        //   <span className='text-wrap break-all'>
        //     {isExpanded ? answerText : shortAnswer}
        //   </span>
        //   {answerText.length > 100 && (
        //     <button
        //       onClick={() => toggleExpand(ele?._id)}
        //       className='text-blue-600 ml-2 hover:underline'
        //     >
        //       {isExpanded ? 'Show Less' : 'Show More'}
        //     </button>
        //   )}
        // </div>,
        <span>{ele?.startDate ? moment(ele?.startDate).format("DD-MM-YYYY hh:mm A") : "N/A"}</span>,
        <span>{ele?.endDate ? moment(ele?.endDate).format("DD-MM-YYYY hh:mm A") : "N/A"}</span>,
        <div className='flex items-center gap-2'>
          <button onClick={() => handleUpdateLogic(ele)}>
            <FaRegEdit
              className='w-5 h-5 mx-auto text-[#07071C]'
              title='update'
            />
          </button>
          {/* <button onClick={() => handleDeleteLogic(ele?._id)}>
            <AiOutlineDelete
              className='w-5 h-5 mx-auto text-red-500'
              title='delete'
            />
          </button> */}
        </div>
      ]
    })

  const apiRequestData = {
    keyWord: keyWord,
    pageNo: pageNo,
    size: size,
    formDate: "",
    toDate: "",
  }

  useEffect(() => {
    dispatch(getICOList(apiRequestData))
  }, [dispatch, pageNo, size, keyWord])

  const handleUpdateLogic = ico => {
    setIsUpdateMode(true)
    setFormData({
      id: ico?._id,
      name: ico.name,
      description: ico.description,
      startDate: moment(ico.startDate).format('YYYY-MM-DDTHH:mm'),
      endDate: moment(ico.endDate).format('YYYY-MM-DDTHH:mm'),
      videoUrl: ico.videoUrl
    })
    setIsModalOpen(true)
  }

  const validation = () => {
    const errors = {}
    if (!formData.name || formData.name.length < 5 || formData.name.length > 1000) {
      errors.name = 'Name is required and should be between 5-100 characters'
    }
    if (!formData.description || formData.description.length < 5 || formData.description.length > 1000000) {
      errors.description = 'Description is required and should be between 5-500 characters'
    }
    if (!formData.startDate) {
      errors.startDate = 'Start date is required'
    }
    if (!formData.endDate) {
      errors.endDate = 'End date is required'
    }
    if (formData.startDate && formData.endDate && new Date(formData.endDate) <= new Date(formData.startDate)) {
      errors.endDate = 'End date must be after start date'
    }
    return errors
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const validationErrors = validation()
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      return
    }

    const submitData = {
      ...formData,
      startDate: new Date(formData.startDate).getTime(),
      endDate: new Date(formData.endDate).getTime()
    }

    try {
      setIsLoading(true)
      if (isUpdateMode) {
        await dispatch(updateIco(submitData)).unwrap()
        toast.success('ICO updated successfully')
      } else {
        // await dispatch(createICO(submitData)).unwrap()
        toast.success('ICO created successfully')
      }
      setIsModalOpen(false)
      setFormData(initialFormState)
      dispatch(getICOList(apiRequestData))
    } catch (error) {
      toast.error(error?.message || 'Something went wrong')
    } finally {
      setIsLoading(false)
    }
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }))
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const onPageChange = newPageNo => {
    setPageNo(newPageNo)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setFormData(initialFormState)
    setErrors({})
    setIsDeleteModalOpen(false)
    setIsUpdateMode(false)
  }




  // const handleDeleteLogic = icoId => {
  //   setIsDeleteModalOpen(true)
  // }

  const confirmDelete = async () => {
    try {
      setIsLoading(true)
      // await dispatch(deleteICO({ id: deleteId })).unwrap()
      toast.success('ICO deleted successfully')
      dispatch(getICOList(apiRequestData))
    } catch (error) {
      toast.error(error?.message || 'Failed to delete ICO')
    } finally {
      setIsLoading(false)
      setIsDeleteModalOpen(false)
    }
  }

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false)
  }

  return (
    <div className='p-4'>
      <Loader loading={loading || isLoading} />
      <div className='space-y-4'>
        <div className='flex justify-between items-center'>
          <h2 className='text-xl font-semibold text-white'>
            ICO Management
          </h2>
        </div>
        <div className='bg-white/10 p-4 rounded-lg shadow'>
          <Table
            tableHeadings={tableHeadings}
            data={tableRows}
            showExtraAdd={false}
            onAdd={() => {
              setIsModalOpen(true)
              setIsUpdateMode(false)
              setFormData(initialFormState)
            }}
            searchTerm={keyWord}
            setSearchTerm={setKeyWord}
          />
        </div>
      </div>

      <AddUpdateICO
        handleSubmit={handleSubmit}
        handleInputChange={handleInputChange}
        isModalOpen={isModalOpen}
        errors={errors}
        form={formData}
        closeModal={closeModal}
        isLoading={isLoading}
      />

      <DeletePopup
        DeleteHeading={'Are you sure you want to delete this ICO?'}
        isDeleteModalOpen={isDeleteModalOpen}
        closeDeleteModal={closeDeleteModal}
        confirmDelete={confirmDelete}
      />

      {Math.ceil(total / size) > 1 && (
        <Pagination
          totalPages={Math.ceil(total / size)}
          currentPage={pageNo}
          onPageChange={onPageChange}
        />
      )}
    </div>
  )
}

export default ICO